module.exports = __webpack_public_path__ + "media/bootstrap-icons/subtract-b630527c.svg";